import { inject, Injector } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserService } from '../services/user.service';
import { CommonService } from '../services/common.service';

export const RoleGuard: CanActivateFn = async(route, state) => {
  const injector = inject(Injector);
  const userService = injector.get(UserService);
  const commonService = injector.get(CommonService);
  const router = injector.get(Router);
  const url = state.url;

  const isManager = await commonService.isManager();
  const isManagerOrCaptain = await userService.isUserManagerOrCaptain();

  // Managers can access everything
  if (isManager) {
    return true;
  }

  // All settings routes are manager-only
  if (url.startsWith('/settings')) {
    router.navigate(['/dashboard']);
    return false;
  }

  // Captains can access non-settings routes (tournaments, practices, etc.)
  if (isManagerOrCaptain) {
    return true;
  }

  router.navigate(['/dashboard']);
  return false;
};

// CRT-471 Task 8.3.3: TreasurerGuard reads server-issued club capabilities instead of
// re-deriving the treasurer role client-side. /settings/fees gates on canManageFees;
// /settings/expense-config gates on canManageExpenseConfig.
// Falls back to isTreasurerOfCurrentClub() when caps are absent (e.g. first login
// before the server returns the capabilities payload), preserving existing behaviour.
export const TreasurerGuard: CanActivateFn = async (route, state) => {
  const injector = inject(Injector);
  const userService = injector.get(UserService);
  const router = injector.get(Router);
  const url = state.url;
  const caps = await userService.currentClubCapabilities();
  let allowed: boolean;
  if (caps) {
    if (url.includes('/expense-config')) {
      allowed = caps.canManageExpenseConfig === true;
    } else {
      // /settings/fees (and any future treasurer-gated settings routes)
      allowed = caps.canManageFees === true;
    }
  } else {
    // Fallback: no capabilities in localStorage yet — use the legacy role check.
    allowed = await userService.isTreasurerOfCurrentClub();
  }
  if (!allowed) {
    router.navigate(['/dashboard']);
    return false;
  }
  return true;
};
